const Validate = values => {
    const errors = {};
    const urlPattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)/;
    if (values.redirection_url !== "" && values.redirection_url !== null && !values.redirection_url.match(urlPattern))
        errors.redirection_url = "Please enter a valid Custom Redirection";
    return errors;
};

export default Validate;